import { Button } from "@mgdx/ui/components/Button";
import { SubtleButton } from "@mgdx/ui/components/SubtleButton";
import { Text } from "@mgdx/ui/components/Text";
import { Title } from "@mgdx/ui/components/Title";

import { AppExternalLink } from "../../ui/AppExternalLink";
import styles from "./index.module.css";

export type AgreementNewTermsReasonViewProps = {
  isLoading?: boolean;
  onClickAgreement: VoidFunction;
  onClickShowWithdraw: VoidFunction;
};

export const AgreementNewTermsReasonView = ({
  isLoading,
  onClickAgreement,
  onClickShowWithdraw,
}: AgreementNewTermsReasonViewProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Title as="h2" className="mb-2">
          薬急便の利用規約変更について
        </Title>

        <Text>2024年11月5日(火曜)に主に以下の理由で利用規約を変更いたしました。</Text>

        <Title fontSize="m">変更理由</Title>

        <Text>利用者様からお預かりする個人情報の提供先・提供目的の一部拡大</Text>

        <Text>
          詳しくは、
          <AppExternalLink
            appearance="text"
            href="https://help.yqb.jp/hc/ja/articles/10922429689871-利用規約の変更予告と変更概要のお知らせ"
            title="薬急便利用規約の変更詳細を開く"
          >
            薬急便利用規約の変更詳細
          </AppExternalLink>
          をご確認ください。
        </Text>

        <Text>
          利用者様がより便利にサービスをお使いいただけるようご理解のほどお願い申し上げます。なお利用者様からお預かりする個人情報は、当社の
          <AppExternalLink
            appearance="text"
            href="https://www.mg-dx.co.jp/privacy-policy/"
            title="プライバシーポリシーを開く"
          >
            プライバシーポリシー
          </AppExternalLink>
          に基づき適切に管理いたします。
        </Text>

        <Text>利用規約の変更にご同意いただける場合は「同意して利用する」を押してサービスにお進みください。</Text>
      </div>

      <div className={styles.bottom}>
        <Button loading={isLoading} onClick={onClickAgreement}>
          同意して利用する
        </Button>

        <SubtleButton onClick={onClickShowWithdraw}>退会する</SubtleButton>
      </div>
    </div>
  );
};
